import { StyleSheet } from 'react-native';

import { Fonts } from '@vfgroup-oneplatform/foundation/Components/Themes';

export default StyleSheet.create({
  contentContainer: {
    paddingHorizontal: 16.6,
    paddingBottom: 30,
  },
  subHeaderTitle: {
    fontSize: 25.1,
    lineHeight: 31.4,
  },
  subHeaderSubTitle: {
    fontSize: 18.8,
    lineHeight: 25.1,
    fontWeight: 'normal',
    fontFamily: Fonts.type.VFFont,
  },
  manualRefresh: { marginBottom: 10, marginLeft: 0 },
});
